var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "content-main" }, [
      _vm.item.brand && _vm.item.brand !== "unknown"
        ? _c("div", { staticClass: "product-brand" }, [
            _vm._v("\n      " + _vm._s(_vm.item.brand) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _c(
          "h3",
          { staticClass: "product-title" },
          [
            _c(
              "router-link",
              { staticClass: "product-title-link", attrs: { to: _vm.path } },
              [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.item.region && _vm.item.region !== "unknown"
          ? _c("div", { staticClass: "product-region" }, [
              _vm._v("\n        " + _vm._s(_vm.item.region) + "\n      "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.hasVarietal
        ? _c("div", { staticClass: "product-subtitle" }, [
            _vm._v("\n      " + _vm._s(_vm.varietal) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "product-description",
        domProps: { innerHTML: _vm._s(_vm.item.abstract) },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-actions" }, [
      _vm.showPrice
        ? _c("div", { staticClass: "pricing-region simple-display" }, [
            _vm.packPricingEnabled
              ? _c("div", { staticClass: "pack-item-element" }, [
                  _c("div", { staticClass: "pack-item" }, [
                    _c(
                      "div",
                      { staticClass: "price-value" },
                      [
                        _c("PriceElement", {
                          attrs: { price: _vm.packPrice, prepend: "$" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "label-divider" }, [
                          _vm._v("\n              /\n            "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price-label" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.packPriceLabel) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "price-item" }, [
              _c(
                "div",
                { staticClass: "price-value", attrs: { title: "Per Bottle" } },
                [
                  _vm.displayRRP
                    ? _c("PriceElement", {
                        staticClass: "rrp",
                        attrs: { price: _vm.rrpPrice },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("PriceElement", {
                    staticClass: "sale-price",
                    attrs: { price: _vm.sellPrice },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-actions" },
        [
          _c("HighlightButton", {
            class: _vm.stockManagedClass,
            attrs: {
              disabled: _vm.outOfStock,
              title: _vm.stockManagedText,
              "button-type": "pill",
              "button-style": "solid",
              "button-size": "small",
              button: "",
            },
            on: { clicked: _vm.addToCartLinkClicked },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }